import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import { requestLoadWorksheet } from 'services/worksheet/actions';
import { WorksheetDate, WorksheetType } from 'services/worksheet/types';

interface OwnProps {
    worksheetDate?: WorksheetDate | undefined;
    worksheetOperatorPersonId?: string | undefined;
    worksheetType: WorksheetType;
}

interface DispatchProps {
    requestLoadWorksheet: typeof requestLoadWorksheet;
}

type Props = OwnProps & DispatchProps;

export class WorksheetRequestComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        this.handleRequest();
    }

    componentDidUpdate(prevProps: Props): void {
        if (isEqual(prevProps, this.props)) {
            this.handleRequest();
        }
    }

    handleRequest = (): void => {
        const {
            worksheetDate,
            worksheetOperatorPersonId,
            worksheetType,
            ...props
        } = this.props;

        if (worksheetDate && worksheetOperatorPersonId) {
            props.requestLoadWorksheet({
                date: worksheetDate,
                operatorPersonId: parseInt(worksheetOperatorPersonId, 10),
                type: worksheetType
            });
        }
    };

    render(): null {
        return null;
    }
}

export default connect(null, {
    requestLoadWorksheet
})(WorksheetRequestComponent);
